import React from 'react';
import './Text-tech.css';

const Texttech = () => {
  return (
    
    <div className='textte'>
      
    <h1  className='text2te'>BON A SAVOIR</h1>
      <p id='serv'>
      Le service technique d'une Mairie est un département clé chargé de la gestion des infrastructures et des travaux publics de la commune. Son rôle principal est 
      d'assurer le bon fonctionnement, l'entretien et le développement des infrastructures
      municipales et des équipements publics. Voici quelques-unes des principales responsabilités des services techniques d'une mairie.
      </p>
    </div>
  );
};

export default Texttech;
